module.exports = __webpack_public_path__ + "static/media/male_child.99f5cd3a.svg";